import React, { useState } from "react";
import photo3 from "../../Assets/Images/landing/hero-c.jpg";

const items = [
  {
    q: "Is eZy Watermark really free to use?",
    a: "Yes — the core watermarking tools are free. You can add text, logo, or signature watermarks, process batches, and save templates without paying. Some premium export resolutions and cloud-sync features are available in our paid plan.",
  },
  {
    q: "Do my photos stay on my device?",
    a: "Absolutely. All watermarking happens locally in your browser or in the mobile app. Your original photos are never uploaded to our servers unless you explicitly turn on optional cloud backup.",
  },
  {
    q: "Can I watermark a batch of photos at once?",
    a: "Yes. Drop a folder or select multiple photos and the app will apply your watermark to every image in a single export. You can still adjust individual positions during the review step.",
  },
  {
    q: "What image formats are supported?",
    a: "We support JPG, JPEG, PNG, HEIC, and WebP. Exported images keep their original EXIF, ICC profile, and color data so your files stay intact and print-ready.",
  },
  {
    q: "Can I create and reuse watermark templates?",
    a: "Yes. Save any watermark layout — text, logo, position, opacity, rotation, and tile settings — as a reusable template. Apply it to any future photo with one tap.",
  },
  {
    q: "Is there a mobile app?",
    a: "eZy Watermark is available for iOS and Android. Your templates and settings sync across devices when you sign in, so you can watermark on the go and finish on desktop.",
  },
];

const FAQSection: React.FC = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faqs" className="lr-section">
      <div className="lr-section__inner lr-faqs">
        <div className="lr-faqs__grid">
          <div className="lr-faqs__left">
            <span className="lr-section__eyebrow">FAQs</span>
            <h2 className="lr-section__heading">
              Questions? <span className="lr-text-gradient">Answered.</span>
            </h2>
            <p className="lr-faqs__lede">
              Everything you need to know about protecting your photos with eZy Watermark.
            </p>

            <div className="lr-faqs__visual">
              <div className="lr-faqs__photo-card">
                <img src={photo3} alt="" />
                <div className="lr-faqs__wm-text">© eZy Watermark</div>
                <div className="lr-faqs__shield">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                  Protected
                </div>
              </div>
            </div>
          </div>

          <div className="lr-faqs__list">
            {items.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className={`lr-faqs__item ${isOpen ? "open" : ""}`}>
                  <button
                    className="lr-faqs__q"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                  >
                    <span>{item.q}</span>
                    <span className={`lr-faqs__icon ${isOpen ? "open" : ""}`}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={isOpen ? "white" : "currentColor"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </span>
                  </button>
                  <div
                    className="lr-faqs__a-wrap"
                    style={{ maxHeight: isOpen ? 300 : 0, opacity: isOpen ? 1 : 0 }}
                  >
                    <div className="lr-faqs__a">{item.a}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
